import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { nonLinearStore } from '../../store/NonLinear/NonLinearStore';
import PublicationLog from './PublicationLog';
import PublicationRights from './PublicationRights';
import ProgrammeCategory from './ProgrammeCategory';
import Publication from './Publication';

class NonLinear extends React.Component {

    componentWillMount() {
        if (this.props.programmeId) {
            this.props.isEditableForm(this.props.programmeId);
            this.props.getPlatforms(this.props.programmeId);
            this.props.getValidationFlag(this.props.programmeId);
            this.props.getInitData(this.props.programmeId);
        }
    }

    componentDidUpdate() {
        this.refs.chkAllInformationEntered.checked = this.props.isValid;
    }

    getIsEditable(editHeader, canEdit) {
        return editHeader === 'editheader' ? false : canEdit;
    }

    handleAllInformationEntered(event) {
        this.props.validateForm(this.props.programmeId, event.target.checked);
    }

    isValidationFailed() {
        if (this.props.validationResult && this.props.validationResult.length > 0) {
            return true;
        }

        return false;
    }

    handleKeyDown = function (e) {
        if (e.key === 'Enter' && e.shiftKey === false) {
            e.preventDefault();
            this.messageOnClickHandler(document.activeElement.getAttribute('controlId'));
            return false;
        }
    }

    messageOnClickHandler(controlId) {
        const control = document.getElementById(controlId);

        if (control) {
            control.focus();
        }
    }

    renderAddPublication() {
        if (this.getIsEditable(this.props.headerAction, this.props.canEditForm)) {
            return (
                <div>
                    <div className='bottomHorizontalRule'>
                        <h2 className='h2tablecell'>Add Publication</h2>
                    </div>
                    <Publication
                        programmeId={this.props.programmeId}
                        canEdit={this.props.canEditForm}
                        platforms={this.props.platforms}
                        validationResult={this.props.validationResult}
                        onValidationError={(messages) => this.onValidationError(messages)} />
                </div>
            );
        }
        return '';
    }

    renderValidationMessages() {
        const control = document.getElementById('messagepanel');

        if (control) {
            if (this.isValidationFailed()) {
                if (!control.hasAttribute('role')) {
                    control.setAttribute('role', 'alert');
                }
            }
            else {
                if (control.hasAttribute('role')) {
                    control.removeAttribute('role');
                }
            }
        }

        if (this.isValidationFailed()) {
            return (
                <div>
                    <div className='pl-2 pt-2'>Some input fields were not entered correctly:</div>
                    <div className='p-2'>
                        <div className='col-md-12'>
                            {this.props.validationResult.map(item =>
                                <div className='pt-1' key={item.controlId}>
                                    - <a tabIndex='0' className='validationMessage' onClick={() => this.messageOnClickHandler(item.controlId)}>{item.message}</a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        }

        return '';
    }

    onValidationError(messages) {
        this.props.addValidationMessage(messages);
    }

    renderOtherComponents() {
        if (!this.props.isLoading) {
            return (
                <div>
                    <div id='messagepanel' className={this.isValidationFailed() ? 'message-warning' : ''} onKeyDown={(e) => { this.handleKeyDown(e); }} style={{ margin: '5px 0px' }}>
                        {this.renderValidationMessages()}
                    </div>
                    {this.renderAddPublication()}
                    <PublicationLog
                        programmeId={this.props.programmeId}
                        canEdit={this.getIsEditable(this.props.headerAction, this.props.canEditForm)}
                        platforms={this.props.platforms}
                        validationResult={this.props.validationResult}
                        onValidationError={(messages) => this.onValidationError(messages)} />
                    <PublicationRights
                        programmeId={this.props.programmeId}
                        canEdit={this.getIsEditable(this.props.headerAction, this.props.canEditForm)}
                        validationResult={this.props.validationResult}
                        onValidationError={(messages) => this.onValidationError(messages)} />
                    <ProgrammeCategory
                        programmeId={this.props.programmeId}
                        canEdit={this.getIsEditable(this.props.headerAction, this.props.canEditForm)}
                        validationResult={this.props.validationResult}
                        onValidationError={(messages) => this.onValidationError(messages)} />
                </div>
            );
        }

        return <div>Loading...</div>;
    }

    render() {
        return (
            <div>
                <div className='text-right'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <label htmlFor='chkAllInformationEntered' className='checkBoxLabel'><h2 className='h2Neutral'>All Publications Information Entered</h2>
                                <input name='chkAllInformationEntered' ref='chkAllInformationEntered' type='checkbox' id='chkAllInformationEntered' className='ml-1' defaultValue="false" defaultChecked={this.props.isValid}
                                    onChange={(event) => this.handleAllInformationEntered(event)} disabled={!this.getIsEditable(this.props.headerAction, this.props.canEdit)} />
                            </label>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            Fields marked with an <span className='mandatory'>*</span> are mandatory
                        </div>
                    </div>
                </div>

                {this.renderOtherComponents()}
            </div>
        );
    }
}

export default connect(
    state => state.nonLinear,
    dispatch => bindActionCreators(nonLinearStore, dispatch)
)(NonLinear);


// WEBPACK FOOTER //
// ./src/components/NonLinear/NonLinear.js